import React from 'react';
import {
    SectionWrapper,
    SectionHeader,
    SectionContainer,
    StyledSectionDescription,
    SectionImageWrapper,
    SectionHeaderLogoWrapper,
    SectionHeaderLogoText
} from './SectionStyles';
import styled from "styled-components";
import { Image } from "UI-Dash-Commons-UI";

const SectionLogo = require('../images/screen2-max-logo.svg');
const SectionLogoAltText = 'logo';
const SectionLogoWidth = '109px';
const SectionLogoHeight = '33px';

const SectionImage = require('../images/screen2-dashboard-graphic.png');
const SectionImageAltText = 'dashboardImage'
const SectionImageWidth = '273px';
const SectionImageHeight = '184px';

const HeaderLogoText = 'Our Solutions'
const HeaderText = 'Maximize your revenue with in-app bidding.';
const SectionDescriptionText = 'Join over 10,000+ developers using our monetization solution.';

const Section2: React.FunctionComponent = () => {

    return <SectionContainer>
        <SectionWrapper>
            <SectionHeaderLogoWrapper>
                <SectionHeaderLogoText>
                    {HeaderLogoText}
                </SectionHeaderLogoText>
                <Image
                    alt={SectionLogoAltText}
                    src={SectionLogo}
                    width={SectionLogoWidth}
                    height={SectionLogoHeight}
                />
            </SectionHeaderLogoWrapper>
            <StyledSectionHeader>
                {HeaderText}
            </StyledSectionHeader>
            <StyledSectionDescription>
                {SectionDescriptionText}
            </StyledSectionDescription>
            <StyledImageWrapper>
                <Image
                    alt={SectionImageAltText}
                    src={SectionImage}
                    width={SectionImageWidth}
                    height={SectionImageHeight}
                />
            </StyledImageWrapper>
        </SectionWrapper>
    </SectionContainer>
};

const StyledImageWrapper = styled( SectionImageWrapper )`
    margin: 26px 50px 0px 108px;
`;

const StyledSectionHeader = styled( SectionHeader)`
    margin: 0 92px 16px 92px;
    font-size: 20px;
    line-height: 27px;
`;

export default Section2;
